import { render, staticRenderFns } from "./TagField.vue?vue&type=template&id=44a13356&"
import script from "./TagField.vue?vue&type=script&lang=js&"
export * from "./TagField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports